export default "__VITE_ASSET__IArJZtwB__"